import { GlobalResponseObject } from "../../common";
import { LatestNewQuestionModel } from "./latest-new-questions-model";

export class LatestNewQuestionsResponse extends GlobalResponseObject {
    data: LatestNewQuestionModel[];
    availableLanguages: string[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data: LatestNewQuestionModel[], availableLanguages: string[] = []) {
        super(status, errorCode, internalMessage);
        this.data = data;
        this.availableLanguages = availableLanguages;
    }
}